<div class="confirm-payment-container d-flex flex-column gap-4">
  <button type="button" class="btn btn-primary home-btn" (click)="navigateHome()">
    <i class="fa-solid fa-house me-2"></i>Home
  </button>

  <div class="payment-container card p-4">
    <h1 class="title mb-4">Privacy Statement</h1>

    <ol class="ps-3">
      <li>
        This is a Government of Singapore digital service.
      </li>
      <li>
        If you are only browsing this digital service, we do not capture data that allows us to identify you individually.
      </li>
      <li>
        We may use "cookies" for our digital services, where a small data file is sent to your browser to store and track information about you when you enter our digital service. The cookie is used to track information such as the number of users and their frequency of use, profiles of users and their preferred digital services. While this cookie can tell us when you enter our digital services and which pages you visit, it cannot read data off your hard disk.
      </li>
      <li>
        You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the digital service.
      </li>
      <li>
        If you provide us with personally identifiable data, we may share necessary data with other Government agencies, so as to improve the discharge of public functions, and to serve you in the most efficient and effective way, unless such sharing is prohibited by law. We will NOT share your Personal Data with non-Government entities, except where such entities have been authorised to carry out specific Government services.
      </li>
      <li>
        For your convenience, we may also display to you data you had previously supplied us or other Government agencies. This will speed up the transaction and save you the trouble of repeating previous submissions. Should the data be out-of-date, please supply us with the latest data.
      </li>
      <li>
        To safeguard your Personal Data, all electronic storage and transmission of Personal Data is secured with appropriate security technologies.
      </li>
      <li>
        This digital service may contain links to non-Government digital services whose data protection and privacy practices may differ from ours. We are not responsible for the content and privacy practices of these other digital services and encourage you to consult the privacy notices of those digital services.
      </li>
      <li>
        Please contact
        <a href="mailto:Supcourt_QSM&#64;supcourt.gov.sg">Supcourt_QSM&#64;supcourt.gov.sg</a>
        if you:
        <p>
          a. have any enquiries or feedback on our data protection policies and procedures; and/or. <br>
          b. need more information on or access to data which you have provided directly to us in the past.
        </p>
      </li>
    </ol>
  </div>
</div>
